import {Route} from '@angular/router';
import { AuthenticateComponent } from './authenticate.component';

export const routes: Route[] = [
  {
    path: '',
    component: AuthenticateComponent
  }
];
